var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSelectFolder(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "121px",
    height: "49px",
    viewBox: "0 0 121 49",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "select folder tree") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop-HD",
    transform: "translate(-752.000000, -210.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "select-folder-tree",
    transform: "translate(752.000000, 210.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#F0F0F0",
    x: 9.5,
    y: 42,
    width: 101,
    height: 7
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Triangle",
    fill: "#D8D8D8",
    transform: "translate(1.500000, 45.500000) rotate(90.000000) translate(-1.500000, -45.500000) ",
    points: "1.5 44 3.5 47 -0.5 47"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#F0F0F0",
    x: 19.5,
    y: 28,
    width: 101,
    height: 7
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Triangle",
    fill: "#D8D8D8",
    transform: "translate(11.500000, 32.500000) scale(1, -1) rotate(45.000000) translate(-11.500000, -32.500000) ",
    points: "11.5 31 13.5 34 9.5 34"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#F0F0F0",
    x: 19.5,
    y: 14,
    width: 101,
    height: 7
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Triangle",
    fill: "#D8D8D8",
    transform: "translate(11.500000, 18.500000) scale(1, -1) rotate(45.000000) translate(-11.500000, -18.500000) ",
    points: "11.5 17 13.5 20 9.5 20"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#F0F0F0",
    x: 9.5,
    y: 0,
    width: 101,
    height: 7
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Triangle",
    fill: "#D8D8D8",
    transform: "translate(1.500000, 3.500000) rotate(90.000000) translate(-1.500000, -3.500000) ",
    points: "1.5 2 3.5 5 -0.5 5"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectFolder);
export default __webpack_public_path__ + "static/media/select-folder.acb6da37b0534b622e7a50212aed13eb.svg";
export { ForwardRef as ReactComponent };